<template>
  <div class="confirm-popup">
    <slot name="content" />
    <NotifyComponent
      v-if="errorText"
      class="confirm-popup__error"
      :text="errorText"
    />
    <slot name="footer">
      <div class="confirm-popup__btn-container">
        <button
          type="button"
          class="confirm-popup__cancel"
          @click="$emit('cancel')"
        >
          <slot name="cancel">
            Отмена
          </slot>
        </button>
        <button
          type="button"
          class="confirm-popup__agree"
          :disabled="isLoading"
          @click="$emit('agree')"
        >
          <Transition>
            <AppLoader v-if="isLoading" />
          </Transition>
          <slot name="agree">
            {{ customText ? customText : 'Да, удалить' }}
          </slot>
        </button>
      </div>
    </slot>
  </div>
</template>

<script lang="ts" src="./ConfirmPopup.ts"></script>

<style scoped lang="scss" src="./ConfirmPopup.scss"></style>
